import { render, staticRenderFns } from "./ItemCatalog.vue?vue&type=template&id=c4d010b2"
import script from "./ItemCatalog.vue?vue&type=script&lang=js"
export * from "./ItemCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports